export enum TopUpMethodType {
  QrCodeSlip,
  BankTransfer,
  Invoice,
  Card,
  Crypto,
}
